import { render, staticRenderFns } from "./mobile-tabbar.vue?vue&type=template&id=998da828&scoped=true&"
import script from "./mobile-tabbar.vue?vue&type=script&lang=js&"
export * from "./mobile-tabbar.vue?vue&type=script&lang=js&"
import style0 from "./mobile-tabbar.vue?vue&type=style&index=0&id=998da828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998da828",
  null
  
)

export default component.exports